import type { PartnerDef } from "../schema";
import { blueRocket } from "./blue-rocket";

/** partnerKey → 提携先定義のレジストリ。提携先追加時はここに1行足す。 */
export const partners: Record<string, PartnerDef> = {
  "blue-rocket": blueRocket,
};
